<div class="d-flex justify-content-center mb-3">
    <canvas #vcSigPad class="dynamic-canvas">
    </canvas>
</div>
<div class="d-flex justify-content-center">
    <button #clearSigButton class="mwp-button-secondary" (click)="clearSignature()">
        <mwp-text-translate text="Clear Signature" jsonKey="clearSignature" />
    </button>
</div>